<template>
    <div class="type-in-phone">
        <el-card shadow="always" class="box-card">
            <div slot="header" class="clearfix">
                <div style="text-align: right;">
                    <span type="text" @click="delModule" class="span-del span-com" v-if="index !== 0">删除模块</span>
                    <span type="text" @click="addModule" class="span-add span-com"
                        v-if="phoneArr.length === 1 || phoneArr.length === index + 1">添加模块</span>
                </div>
            </div>
            <div class="m-con">
                <el-form :model="selfPhone" ref="selfPhone" label-width="90px">
                    <el-form-item prop="default.name" label="姓名" :rules="[
                        { min: 2, max: 25, message: '姓名长度输入错误!', trigger: 'blur' }
                    ]">
                        <el-input v-model="selfPhone.default.name" size="mini" show-word-limit maxlength="25"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="default.position" label="疑似职务" :rules="[]">
                        <el-checkbox-group v-model="selfPhone.default.position">
                            <el-checkbox label="法人"></el-checkbox>
                            <el-checkbox label="监事"></el-checkbox>
                            <el-checkbox label="财务"></el-checkbox>
                            <el-checkbox label="人事"></el-checkbox>
                            <el-checkbox label="高管"></el-checkbox>
                            <el-checkbox label="股东"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item prop="default.phone.default.phone" label="手机号" :rules="[
                        { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' },
                        { required: true, message: '请填写手机号！', trigger: 'blur' }
                    ]">
                        <div style="display: flex;gap:0.2rem">
                            <el-input v-model="selfPhone.default.phone.default.phone" size="mini" show-word-limit
                                maxlength="11" clearable ></el-input>
                            <div v-if="!selfPhone.default.phone.domain.length" style="padding-top: 0.1rem;">
                                <i class="el-icon-circle-plus-outline i-b-s" @click="addPhone(0)"></i>
                            </div>
                        </div>
                        <el-radio v-model="selfPhone.default.phone.default.is_wechat" label="1">是微信</el-radio>
                        <el-radio v-model="selfPhone.default.phone.default.is_wechat" label="2">不是微信</el-radio>
                    </el-form-item>
                    <el-form-item :prop="`default.phone.domain.${index}.phone`"
                        v-for="(item, index) in selfPhone.default.phone.domain" :key="index" label="" :rules="[
                        { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' },
                        { required: true, message: '请填写手机号！', trigger: 'blur' }
                    ]">
                        <div style="display: flex;gap: 0.1rem;">
                            <el-input v-model="item.phone" size="mini" show-word-limit maxlength="11"
                                clearable></el-input>
                            <div style="display: flex;padding-top: 0.2rem;">
                                <i v-if="selfPhone.default.phone.domain.length === index + 1"
                                    class="el-icon-circle-plus-outline i-b-s" @click="addPhone(index)"></i>
                                <i class="el-icon-remove-outline i-b-s" @click="handleRemovePhoneForm(index)"></i>
                            </div>
                        </div>
                        <el-radio v-model="item.is_wechat" label="1">是微信</el-radio>
                        <el-radio v-model="item.is_wechat" label="2">不是微信</el-radio>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'TypeInPhone',
    props: {
        index: {
            type: Number
        },
        phoneArr: {
            type: Array
        }
    },
    data() {
        return {
            selfPhone: {
                default: {
                    name: '',
                    position: [],
                    phone: {
                        default: {
                            phone: '',
                            is_wechat: ''
                        },
                        domain: []
                    },
                },
            }
        }
    },
    methods: {
        addPhone(index) {
            this.selfPhone.default.phone.domain.splice(index + 1, 0, { phone: '', is_wechat: '' })
        },
        handleRemovePhoneForm(index) {
            this.selfPhone.default.phone.domain.splice(index, 1)
        },
        addModule() {
            this.$emit('addModule', this.index)
        },
        delModule() {
            this.$emit('delModule', this.index)
        },
        submitForm() {
            this.$refs['selfPhone'].validate((valid) => {
                if (!valid) {
                    return false
                }
            })
        }
    },
}
</script>

<style scoped>
.type-in-phone .i-b-s {
    font-size: x-large;
    cursor: pointer;
}

.type-in-phone .m-con {
    margin-bottom: 0.2rem;
}

.type-in-phone .span-del {
    color: #F56C6C;
}

.type-in-phone .span-add {
    color: #409EFF;
    margin-left: 0.2rem;
}

.type-in-phone .span-com {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/TypeInPhone.vue